export { default as DeleteColumnMapkeyDialog } from './delete-column-mapkey-dialog.component';
export * from './delete-column-mapkey-dialog.component';